<div class="settings-page">
    <div class="settings-page__content">
        <div class="settings-card">
            <div class="settings-card__header">
                <img src="/assets/images/Group 24.svg" alt="" />
                <div class="settings-card__header-headline">
                    <h2>Bine ați venit!</h2>
                    <h4>Setări Proiecte</h4>
                </div>
            </div>
        </div>
    </div>

    <div class="content-box">
        <div class="settings-page-container">
            <mat-button-toggle-group [value]="selectedComponent" (change)="onChange($event)" class="settings-page_menu">
                <mat-button-toggle [value]="option" class="settings-page_menu-item"
                    *ngFor="let option of componentKeys">
                    <div style="text-align: left;">
                        {{ option }}
                    </div>
                </mat-button-toggle>
            </mat-button-toggle-group>
        </div>
        <div class="settings-page__content">
            <ng-container *ngIf="selectedComponent === ProjectsSettings.CATEGORII_PROIECTE">
                <app-categorii-proiecte></app-categorii-proiecte>
            </ng-container>
            <ng-container *ngIf="selectedComponent === ProjectsSettings.SECTIUNI_PROIECTE">
                <app-sectiuni-proiecte></app-sectiuni-proiecte>
            </ng-container>
            <ng-container *ngIf="selectedComponent === ProjectsSettings.STATUSURI_PROIECTE">
                <app-statusuri-proiecte></app-statusuri-proiecte>
            </ng-container>
            <ng-container *ngIf="selectedComponent === ProjectsSettings.TAGURI_PROIECTE">
                <app-taguri-proiecte></app-taguri-proiecte>
            </ng-container>
            <ng-container *ngIf="selectedComponent === ProjectsSettings.FURNIZORI_PROIECTE">
                <app-furnizori-proiecte></app-furnizori-proiecte>
            </ng-container>
            <ng-container *ngIf="selectedComponent === ProjectsSettings.AGENTI_PROIECTE">
                <app-agenti-proiecte></app-agenti-proiecte>
            </ng-container>
            <ng-container *ngIf="selectedComponent === ProjectsSettings.MOTIVE_DELAY_PROIECTE">
                <app-motive-proiecte></app-motive-proiecte>
            </ng-container>
            <ng-container *ngIf="selectedComponent === ProjectsSettings.OPERATORI_PROIECTE">
                <app-operatori-proiecte></app-operatori-proiecte>
            </ng-container>
            <div class="row" *ngIf="selectedComponent == null">
                <div class="col-sm-12 py-5">
                    <div class="row h-100 justify-content-center align-items-center">
                        <div class="col-12 text-center">
                            <div class="py-3">
                                <p class="mb-0">Selectați o secțiune</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>